import { render, staticRenderFns } from "./SetupImportMentions.vue?vue&type=template&id=2be915dc&scoped=true"
import script from "./SetupImportMentions.vue?vue&type=script&lang=js"
export * from "./SetupImportMentions.vue?vue&type=script&lang=js"
import style0 from "./SetupImportMentions.vue?vue&type=style&index=0&id=2be915dc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be915dc",
  null
  
)

export default component.exports